import classNames from 'classnames';
import TimelineItem, {
  TimelineItemType,
} from 'components/generics/Timeline/components/TimelineItem';
import { getStateTimelineItem } from 'components/generics/Timeline/utils/state';
import {
  getStyleTimelineItem,
  TimelineItemStyleOptions,
} from 'components/generics/Timeline/utils/style';
import { HTMLAttributes } from 'react';
import classes from './index.module.scss';

export type TimelineDataType = Omit<
  TimelineItemType,
  'state' | 'isFirst' | 'isLast'
>[];

interface Props extends HTMLAttributes<HTMLDivElement> {
  data: TimelineDataType;
  currentStep: number;
  options?: TimelineItemStyleOptions;
}

export enum TimelineItemState {
  PASSED,
  CURRENT,
  NEXT,
}

const Timeline = ({ data, currentStep, options, className }: Props) => {
  return (
    <div className={classNames(classes.gridContainer, className)}>
      {data.map((item, index) => {
        const state = getStateTimelineItem(currentStep, index);
        const isFirst = index === 0;
        const isLast = index === data.length - 1;
        const isStopStep = item.stopStep;

        const {
          topLineClassName,
          bottomLineClassName,
          circleClassName,
          titleClassName,
          subtitleClassName,
          CircleIcon,
          circleIconClassName,
        } = getStyleTimelineItem(state, isFirst, isLast, options, isStopStep);

        return (
          <TimelineItem
            key={index}
            state={state}
            isFirst={isFirst}
            isLast={isLast}
            topLineClassName={topLineClassName}
            bottomLineClassName={bottomLineClassName}
            circleClassName={circleClassName}
            titleClassName={titleClassName}
            subtitleClassName={subtitleClassName}
            CircleIcon={CircleIcon}
            circleIconClassName={circleIconClassName}
            {...item}
          />
        );
      })}
    </div>
  );
};

export default Timeline;
